import aeonik from "components/utils/aeonik";
import lightFormat from "date-fns/lightFormat";
import type { NavigatorOptions } from "highcharts";
import colors from "tailwindcss/colors";
import tinycolor2 from "tinycolor2";

const navigatorStyles: NavigatorOptions = {
  stickToMax: false,
  adaptToUpdatedData: true,
  margin: 24,
  height: 60,
  outlineWidth: 1,
  outlineColor: colors.slate[200],
  maskFill: tinycolor2(colors.sky[600]).setAlpha(0.06).toRgbString(),
  maskInside: true,
  handles: {
    enabled: true,
    lineWidth: 0,
    width: 10,
    height: 16,
    backgroundColor: colors.zinc[600],
    symbols: ["circle", "circle"],
  },
  series: {
    color: colors.zinc[500],
    lineColor: colors.zinc[300],
    lineWidth: 1.5,
    zIndex: 20,
  },
  yAxis: {
    lineWidth: 0,
    lineColor: colors.slate[200],
    gridLineWidth: 0,
    labels: {
      enabled: false,
    },
  },
  xAxis: {
    showFirstLabel: true,
    showLastLabel: false,
    lineWidth: 0,
    lineColor: colors.slate[200],
    gridLineWidth: 1,
    gridLineColor: colors.slate[100],
    labels: {
      enabled: true,
      style: {
        color: colors.slate[600],
        fontFamily: aeonik.style.fontFamily,
        fontWeight: "600",
        fontSize: "10px",
        textOutline: "none",
      },
      // eslint-disable-next-line func-names, object-shorthand
      formatter: function () {
        // @ts-ignore
        return lightFormat(this.value, "MM/yy");
      },
    },
  },
};

export default navigatorStyles;
